module.exports = __webpack_public_path__ + "static/media/preferred-format.ddd1d7cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/preferred-format.svg
// module id = 440
// module chunks = 0